import styled, { css } from 'styled-components';
import media from 'src/styles/Media.styled';

export const SummaryCard = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: stretch;
    height: 100%;
    width: 100%;
    background-color: #ffffff;
    box-shadow: 0px 0px 6px #00000029;
    border: none;
    border-radius: 6px;
    /* padding: 15px 15px; */
    margin-bottom: 10px;
    margin-top: ${({ marginTop }) => (marginTop ? marginTop : '0px')};
    ${media.mobileDevice`
    border: 1px solid #74DED6;
    margin-bottom: 7px;    
    `}
`;

export const PricingCommentsContainer = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    margin: ${({ margin }) => (margin ? margin : '0')};
`;

export const CommentsContainer = styled.div`
    display: flex;
    width: 100%;
`;

export const PricingComments = styled.p`
    margin: ${({ margin }) => (margin ? margin : '0')};
    font-family: ${({ fontFamily }) =>
        fontFamily ? fontFamily : 'AvenirNextWorld Regular'};
    text-align: left;
    font-size: ${({ fontSize }) => (fontSize ? fontSize : '13px')};
    line-height: 19px;
    letter-spacing: ${({ letterSpacing }) =>
        letterSpacing ? letterSpacing : '-0.1px'};
    color: ${({ fontColor }) => (fontColor ? fontColor : '#000000')};
    opacity: 1;
    width: 100%;
    word-break: break-all;
`;

export const Comments = styled.p`
    width: ${({ width }) => width};
    margin: ${({ margin }) => (margin ? margin : '0')};
    font-family: ${({ fontFamily }) =>
        fontFamily ? fontFamily : 'AvenirNextWorld Regular'};
    text-align: left;
    font-size: ${({ fontSize }) => (fontSize ? fontSize : '13px')};
    line-height: 19px;
    letter-spacing: ${({ letterSpacing }) =>
        letterSpacing ? letterSpacing : '-0.1px'};
    color: ${({ fontColor }) => (fontColor ? fontColor : '#000000')};
    opacity: 1;
    ${({ truncation }) =>
        truncation &&
        css`
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
        `}
`;

export const PricingMore = styled.span`
    display: inline-block;
    color: blue;
    cursor: pointer;
    padding-left: 5px;
`;
